import React from 'react';

interface CustomTextareaProps {
    id: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    rows?: number;
    maxLength?: number;
    disabled?: boolean;
    error?: boolean;
    className?: string;
}

const CustomTextarea: React.FC<CustomTextareaProps> = ({
    id,
    label,
    value,
    onChange,
    placeholder,
    rows = 3,
    maxLength,
    disabled = false,
    error = false,
    className = '',
}) => {
    return (
        <div className={`form-group ${error ? 'has-error' : ''} ${className}`}>
            {label && <label htmlFor={id}>{label}</label>}
            <textarea
                id={id}
                className={`form-control ${error ? 'has-error' : ''}`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                rows={rows}
                maxLength={maxLength}
                disabled={disabled}
            />
        </div>
    );
};

export default CustomTextarea; 